<template>
  <div class="row form-group">
    <template v-for="(item, index) in modelItems">
      <div :key="index + '.FormRow'" class="col">
        <w-input
          :model="item.model"
          :disabled="checkAllProperty(item, 'disabled')"
          :show-error="checkAllProperty(item, 'showError')"
          :placeholder="item.placeholder"
          :type="checkAllProperty(item, 'type')"
          :appendicon="item.appendicon"
          :prependicon="item.prependicon"
          :set-title-as-placeholder="checkAllProperty(item, 'setTitleAsPlaceholder')"
          :tooltip="item.tooltip"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';

// @vuese
// Disabled values component
// // @Group detailsComponents
export default {
  mixins: [componentMixin],
  props: {
    // Przekazuję obiekt z wartościami jak disbaled itp.
    allParametrs: { type: Object, required: false }
  },
  methods: {
    // @vuese
    // Zwraca podane property lub property `all`
    checkAllProperty(item, property) {
      return (this.allParametrs && this.allParametrs[property]) || item[property];
    }
  }
};
</script>
